export const assignmentMap = {
  cookiesTableTitle: 'cookies-table-title',
  cookiesTableText: 'cookies-table-text',
  cookiesTableColHeaders: 'cookies-table-col-headers',
};
export const defaultCookiesSettings = { cookiesTableFonts: [] };
export const FORM_ID = 'cookiesTables';
